import { QueryHookOptions, useQuery } from '@apollo/client';

import { GET_LOG } from './queries';
import { LOGItem } from './types';

export const useLogsByEntityId = (options?: QueryHookOptions) => useQuery<{ logs: LOGItem[] }>(GET_LOG, options);
